import { Helmet } from "react-helmet-async";

export const EnhancedSEO = () => {
  return (
    <Helmet>
      {/* Primary SEO */}
      <title>
        TinyMinds – Fun Learning Games & Stories for Kids (Ages 3–8)
      </title>

      <meta
        name="description"
        content="TinyMinds offers fun learning games, stories, rhymes, and activities for kids aged 3–8. Safe, interactive education for preschool and early learners."
      />

      {/* App & Theme */}
      <meta name="theme-color" content="#8B5CF6" />
      <meta name="msapplication-TileColor" content="#8B5CF6" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="TinyMinds" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="application-name" content="TinyMinds" />

      {/* Canonical & Language */}
      <link rel="canonical" href="https://tinyminds.in" />
      <link rel="alternate" hrefLang="en-IN" href="https://tinyminds.in" />
      <link rel="alternate" hrefLang="x-default" href="https://tinyminds.in" />

      {/* Open Graph (Social Sharing) */}
      <meta property="og:title" content="TinyMinds – Fun Learning for Kids Ages 3–8" />
      <meta
        property="og:description"
        content="Fun and interactive learning games, stories, rhymes, and activities for preschool and early learners."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://tinyminds.in" />
      <meta property="og:image" content="https://tinyminds.in/og-image.png" />
      <meta
        property="og:image:alt"
        content="TinyMinds – Fun Learning Platform for Kids Ages 3–8"
      />
      <meta property="og:site_name" content="TinyMinds" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card (NO account required) */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="TinyMinds – Fun Learning Games for Kids Ages 3–8"
      />
      <meta
        name="twitter:description"
        content="Safe, interactive learning games, stories, and activities for preschool kids."
      />
      <meta name="twitter:image" content="https://tinyminds.in/og-image.png" />

      {/* Performance */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://www.youtube.com" />
      <link rel="preconnect" href="https://i.ytimg.com" />

      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />
      <link rel="dns-prefetch" href="//www.youtube.com" />
      <link rel="dns-prefetch" href="//i.ytimg.com" />

      {/* Robots */}
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />

      {/* ✅ Organization + EducationalOrganization (Merged Correctly) */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": ["Organization", "EducationalOrganization"],
          "name": "TinyMinds",
          "alternateName": "TinyMinds Educational Platform",
          "url": "https://tinyminds.in",
          "logo": "https://tinyminds.in/icons/icon-192.png",
          "description":
            "TinyMinds offers fun learning games, stories, rhymes, and activities for kids aged 3–8. Safe, interactive education for preschool and early learners.",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Support",
            "telephone": "+91-8128805429",
            "email": "info.tinyminds@gmail.com",
            "url": "https://tinyminds.in/contact"
          },
          "sameAs": [
            "https://www.instagram.com/tinyminds2025",
            "https://www.youtube.com/@tinyMinds2025"
          ],
          "foundingDate": "2024",
          "areaServed": "IN",
          "audience": {
            "@type": "Audience",
            "audienceType": "children ages 3–8 and parents"
          }
        })}
      </script>

      {/* WebSite Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "TinyMinds",
          "url": "https://tinyminds.in",
          "description":
            "Interactive educational platform for children with games, stories, activities and learning content for ages 3–8",
          "publisher": {
            "@type": "Organization",
            "name": "TinyMinds"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": "https://tinyminds.in/search?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          },
          "inLanguage": "en-IN",
          "copyrightYear": "2024",
          "copyrightHolder": {
            "@type": "Organization",
            "name": "TinyMinds"
          }
        })}
      </script>
    </Helmet>
  );
};
